import HBLoading from "@/components/HBLoading";
import MyBoardFilter from "@/components/MyBoardFilter";
import Search from "@/components/PinCreator/views/Search";
import { getLastBoards } from "@/services";
import { CheckOutlined } from "@ant-design/icons";
import { useMemoizedFn } from "ahooks";
import { Button, notification } from "antd";
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import styles from "./index.module.less";

/**
 * @param {{
 *   defaultValue?: number[];
 *   onCancel?: () => void;
 *   onOk?: (ids: number[], boards: Board[]) => void;
 * }} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function BoardPicker(props) {
  const [loading, setLoading] = useState(true);

  const [boards, setBoards] = useState([]);
  const [keyword, setKeyword] = useState();
  const [ids, setIds] = useState(props.defaultValue ?? []);
  const [filteredBoardsAmount, setFilterBoardsAmount] = useState();

  const onKeywordChange = useCallback((e) => {
    const val = e.target.value;
    setKeyword(val.slice(0, 32));
  }, []);

  const canItemShow = useCallback((board) => !!board.pin_count, []);

  const init = useCallback(async () => {
    if (!process.browser) return;

    try {
      setLoading(true);
      if (!props.boards) {
        const data = (await getLastBoards({ extra: "cover" })).boards;
        setBoards(data);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
      notification.error({
        message: `出错啦`,
        description: (
          <>
            <h3>请求异常</h3>
            <p>{err.toString()}</p>
          </>
        ),
      });
    }
  }, [props.boards]);

  const onSelectChange = useMemoizedFn((selectedIds) => {
    setIds(selectedIds);
  });

  const { onOk } = props;
  const onOkClick = useCallback(() => {
    onOk &&
      onOk(
        ids,
        boards.filter((r) => ids.includes(r.board_id))
      );
  }, [boards, ids, onOk]);

  const onBoardFilter = useMemoizedFn((_, result) => {
    setFilterBoardsAmount(result.length);
  });

  useEffect(() => {
    init();
  }, [init]); //  only run on Mounted

  return (
    <div className={styles.boardPicker}>
      <Search
        onChange={onKeywordChange}
        hideSearchBtn
        value={keyword}
        placeholder={"搜索画板"}
      />

      {loading ? (
        <div
          style={{
            paddingTop: "120px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <HBLoading size={"24px"} />
        </div>
      ) : (
        <>
          <div
            style={{
              height: "300px",
              textAlign: "center",
              fontSize: "14px",
              fontWeight: "400",
              marginTop: "24px",
              display: !(
                (keyword && filteredBoardsAmount < 1) ||
                !boards.length
              )
                ? "none"
                : "block",
            }}
          >
            尚无画板
          </div>
          <div
            style={{
              display:
                (keyword && filteredBoardsAmount < 1) || !boards.length
                  ? "none"
                  : "block",
            }}
          >
            <MyBoardFilter
              className={classNames(styles.boardFilter, "custom-scroll")}
              boards={boards}
              keyword={keyword}
              canItemShow={canItemShow}
              selectable={true}
              value={ids}
              showCreator={false}
              mode={"multiple"}
              limitByPinCount={10}
              limitByPrivate={true}
              SelectedMark={() => (
                <div className={styles.selectMark}>
                  <CheckOutlined />
                </div>
              )}
              onSelected={onSelectChange}
              onFilter={onBoardFilter}
            />
          </div>
        </>
      )}
      <div className={styles.actions}>
        <Button
          style={{ width: "88px", boxShadow: "none" }}
          onClick={props.onCancel}
        >
          取消
        </Button>
        <Button style={{ width: "88px" }} type={"primary"} onClick={onOkClick}>
          添加
        </Button>
      </div>
    </div>
  );
}
